import { z } from 'zod';
import { ListboxOption, OptionId } from './SelectField.types';

export const findOptionFromOptionId = (
  options: ListboxOption[],
  optionId: string | number,
  defaultOption: ListboxOption = { label: '', optionId: '' },
): ListboxOption => {
  const option = options.find((option) => option.optionId === optionId);
  return option || defaultOption;
};

export const extractOptionIdFromOption = (option: ListboxOption): OptionId => {
  return option.optionId;
};

export const listBoxOption = z.object({
  label: z.string(),
  optionId: z.string().or(z.number()),
  iconSrc: z.string().optional(),
});
